<div *ngIf="isVisible" @slideFade>
  <a
    #bar
    class="notification-bar"
    [attr.data-type]="type"
    [attr.role]="'region'"
    [attr.aria-label]="'お知らせ'"
    [class.notification-bar--no-link]="!href"
    [href]="href || null"
    [attr.target]="target || null"
    [attr.rel]="isNewTab() ? 'noopener noreferrer' : null"
    (click)="onAnchorClick($event)"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</div>

<ng-template #content>
  <div class="notification-bar-inner">
    <span class="notification-bar-icon" aria-hidden="true">
      <mat-icon class="icon">{{ getIconName() }}</mat-icon>
    </span>
    <span class="notification-bar-body">
      <ng-content></ng-content>
    </span>
    <button *ngIf="closeable" type="button" class="notification-bar-close" aria-label="お知らせを閉じる" (click)="close($event)">
      <mat-icon class="icon">close</mat-icon>
    </button>
  </div>
</ng-template>
